/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Invoice/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Invoice({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/PaymentSources/SelectedOption/Invoice"
  
}) {
  return null
}